import { useContext } from 'react';
import { QuestionOperationsContext } from '@/features/questionnaires/contexts/questionOperationsContext';

export const useQuestionOperationsContext = () => {
  const context = useContext(QuestionOperationsContext);
  if (context === undefined) {
    throw new Error(
      'useQuestionOperationsContext must be used within a QuestionOperationsProvider',
    );
  }
  return context;
};
